module.exports = __webpack_public_path__ + "img/time_flag.4d5a1838.svg";